import * as React from "react";
import { SVGProps } from "react";

export const IconUnknown = (props: SVGProps<SVGSVGElement>) => (
  <svg
  width={20}
  height={19}
  viewBox="0 0 20 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.593 1.504L19.6 13.64c1.145 1.98-.305 4.496-2.614 4.496H2.993c-2.31 0-3.734-2.491-2.59-4.496L7.414 1.504c1.14-2.005 4.035-2.005 5.18 0zm-2.072 13.34a.623.623 0 01-.584.848.625.625 0 11.585-.848zm.598-8.215a2.117 2.117 0 011.006 1.798 2.1 2.1 0 01-.29 1.066 2.118 2.118 0 01-1.82 1.043h-.111a.625.625 0 00-.625.625V13.192a.627.627 0 00.625.625c.345 0 .625-.28.625-.625V11.747a3.36 3.36 0 001.278-.478 3.36 3.36 0 00-1.791-6.202H9.78A3.281 3.281 0 006.5 8.35a.625.625 0 101.25 0c0-1.122.91-2.032 2.031-2.032h.235a2.1 2.1 0 011.1.31l.004.002z"
    fill="#828282"
  />
</svg>
);
